export default __webpack_public_path__ + "static/media/wood1.be392874.jpg";